export default "__VITE_ASSET__ddd0f3b1__"